import ThreeColumn from './threeColumn/threeColumn'
import TwoColumn from './twoColumn/twoColumn'
import SingleColumn from './singleColumn/singleColumn'

export {ThreeColumn, TwoColumn, SingleColumn}
